import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { Sie4ExportConfiguration } from '../../model/company';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { SelectionItem } from '../../../core/component/select/select.component';
import { createDimensionSelection } from '../../../accounting/model/const/enum';

@Component({
    selector: 'app-company-sie-config',
    templateUrl: './company-sie-config.component.html',
    styleUrls: ['./company-sie-config.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanySieConfigComponent implements OnInit {
  constructor(
    private _fb: FormBuilder,
    private _cf: FormControlExFactory
  ) {}
  @Input() dataContext: Sie4ExportConfiguration;
  private _form: FormGroup;
  @Input() set form(value: AbstractControl) {
    this._form = value as FormGroup;
  }
  get form(): FormGroup {
    return this._form;
  }
  @Input() dimensionSelection: SelectionItem[] = createDimensionSelection();

  encodingNameSelection: SelectionItem[] = [
    new SelectionItem('CP-437', 'CP-437'),
    new SelectionItem('CP-1252', 'CP-1252'),
    new SelectionItem('UTF-8', 'UTF-8'),
    new SelectionItem('UTF-8 BOM', 'UTF-8 BOM'),
  ];

  ngOnInit(): void {
    if (this.form.contains('includeAccountingYearDescription')) return;

    this.form.addControl(
      'includeAccountingYearDescription',
      this._cf.create('COMPANY.INCLUDE_ACCOUNTING_YEAR_IN_SIE4', this.dataContext.includeAccountingYearDescription)
    );
    this.form.addControl(
      'includeClosingBalance',
      this._cf.create('COMPANY.INCLUDE_CLOSING_BALANCE_IN_SIE4', this.dataContext.includeClosingBalance)
    );
    this.form.addControl(
      'includeOrganizationNo',
      this._cf.create('COMPANY.INCLUDE_ORGANIZATIONNO_IN_SIE4', this.dataContext.includeOrganizationNo)
    );
    this.form.addControl(
      'includeCompanyCode',
      this._cf.create('COMPANY.INCLUDE_COMPANYCODE_IN_SIE4', this.dataContext.includeCompanyCode)
    );
    this.form.addControl(
      'includeVerificationNumber',
      this._cf.create(
        'COMPANY.INCLUDE_VERIFICATION_NUMBER_IN_SIE4',
        this.dataContext.includeVerificationNumber,
        null,
        null,
        'COMPANY.INCLUDE_VERIFICATION_NUMBER_IN_SIE4_HELP'
      )
    );
    this.form.addControl(
      'encodingName',
      this._cf.create('COMPANY.SIE4_ENCODING', this.dataContext.encodingName, null, null, 'COMPANY.SIE4_ENCODING_HELP')
    );
    this.form.addControl(
      'replaceLocalCharacters',
      this._cf.create(
        'COMPANY.SIE4_REPLACE_LOCAL_CHARS',
        this.dataContext.replaceLocalCharacters,
        null,
        null,
        'COMPANY.SIE4_REPLACE_LOCAL_CHARS_HELP'
      )
    );
    this.form.addControl('dim1', this._cf.create('ACCOUNTING_EXPORT.DIMENSION_1', this.dataContext.dim1));
    this.form.addControl('dim2', this._cf.create('ACCOUNTING_EXPORT.DIMENSION_2', this.dataContext.dim2));
    this.form.addControl('dim3', this._cf.create('ACCOUNTING_EXPORT.DIMENSION_3', this.dataContext.dim3));
    this.form.addControl('dim4', this._cf.create('ACCOUNTING_EXPORT.DIMENSION_4', this.dataContext.dim4));
    this.form.addControl('dim5', this._cf.create('ACCOUNTING_EXPORT.DIMENSION_5', this.dataContext.dim5));
    this.form.addControl('dim6', this._cf.create('ACCOUNTING_EXPORT.DIMENSION_6', this.dataContext.dim6));
    this.form.addControl('dim7', this._cf.create('ACCOUNTING_EXPORT.DIMENSION_7', this.dataContext.dim7));
    this.form.addControl('dim8', this._cf.create('ACCOUNTING_EXPORT.DIMENSION_8', this.dataContext.dim8));
  }
}
